// E-belge modülü enum'ları.
// Sayısal değerler JewApi.Data.Domain/Enums/DbEnums.cs ile BİREBİR aynıdır;
// arka uç tarafında Jew.Integrations.EInvoice.Enums karşılıklarıyla da eşleşir.

export enum EInvoiceProviderType {
  None = 0,
  Nilvera = 1,
  Mock = 2,
  /** İş Net Nettefatura (SOAP). Kimlik IP + VKN ile doğrulanır, API anahtarı kullanmaz. */
  Nettefatura = 3,
  /**
   * Uyumsoft (SOAP). Kimlik kullanıcı adı + şifre: şifre API anahtarı alanında,
   * kullanıcı adı sağlayıcı ayarı JSON'undaki `Username` alanında.
   */
  Uyumsoft = 4,
  /** EDM Bilişim (SOAP). Kimlik kullanıcı adı + şifre: şifre API anahtarı alanında. */
  Edm = 5,
}

export enum EInvoiceDocumentType {
  None = 0,
  EInvoice = 1,
  EArchive = 2,
  EDespatch = 3,
}

export enum EInvoiceDirection {
  Outgoing = 1,
  Incoming = 2,
}

export enum EInvoiceProfileType {
  None = 0,
  /** TEMELFATURA — alıcı sistem üzerinden reddedemez. Varsayılan. */
  Basic = 1,
  /** TICARIFATURA — alıcının 8 gün yanıt hakkı var. */
  Commercial = 2,
  Export = 3,
  TravellerInvoice = 4,
  EArchive = 5,
  Public = 6,
  Hks = 7,
  Energy = 8,
  MedicineAndMedicalDevice = 9,
  SpecialInvoice = 10,
  InvestmentIncentive = 11,
  Idis = 12,
}

export enum EInvoiceTypeCode {
  None = 0,
  Sales = 1,
  Return = 2,
  Exception = 3,
  Withholding = 4,
  ExportRegistered = 5,
  Cancel = 6,
  SpecialTaxBase = 7,
  Sgk = 8,
  WithholdingReturn = 9,
  Commissioner = 10,
}

export enum EInvoiceDocumentStatus {
  Unknown = 0,
  Draft = 1,
  Pending = 2,
  Sent = 3,
  Succeed = 4,
  Error = 5,
  Cancelled = 6,
  /** Entegratörün taslak ucuna gönderildi (GİB'e/alıcıya iletilmedi); Onayla ve Gönder ile Sent'e geçer. */
  ProviderDraft = 7,
  /**
   * Entegratöre ulaştı, portalında onay bekliyor (onay bekleyerek gönderim —
   * Nettefatura). Taslak değildir; Gönderildi ile Başarılı arasında. Onay
   * portaldan verilir, durum kontrolü getirir.
   */
  AwaitingApproval = 8,
}

/**
 * Has fiyatı (parite) girilmediğinde otomatik kurun okunacağı kapanış günü —
 * e-fatura ve gider pusulası (EInvoiceSetting.closingRateDay). Varsayılan bir
 * önceki gün: belge kesilirken o günün kapanışı çoğu zaman henüz oluşmamıştır.
 */
export enum ClosingRateDay {
  PreviousDay = 0,
  SameDay = 1,
}

export const CLOSING_RATE_DAY_OPTIONS: { value: ClosingRateDay; label: string }[] = [
  { value: ClosingRateDay.PreviousDay, label: 'Bir önceki gün' },
  { value: ClosingRateDay.SameDay, label: 'Aynı gün' },
];

export enum EInvoiceAnswerCode {
  Unknown = 0,
  WaitingForApproval = 1,
  Approved = 2,
  Rejected = 3,
  AnsweredAutomatically = 4,
}

/** Fatura satırının kaynağı. */
export enum EInvoiceLineSourceType {
  /** Yasal stok kalemi — birincil yol. */
  LegalStock = 1,
  /** Gerçek stok ürünü (Product). */
  RealStock = 2,
  /** Serbest satır. */
  Manual = 3,
  /** Gelen belgeden çekilen ham satır. */
  Incoming = 4,
}

/** Gelen belgenin yasal stoğa işlenme durumu. Mükerrer girişi engelleyen tek alan. */
export enum DocumentStockStatus {
  /** Giden belgelerde her zaman bu değer. */
  NotApplicable = 0,
  Pending = 1,
  Processed = 2,
  /** Emtia alımı değil (elektrik, kira, hizmet faturası). */
  Ignored = 3,
}

/**
 * Giden e-Faturanın PDF'inin müşteriye e-postalanma durumu
 * (EInvoiceSetting.sendInvoiceEmailToCustomer).
 */
export enum EInvoiceEmailStatus {
  /** Henüz karar verilmedi: belge gönderilmedi ya da durumu teyit edilmedi. */
  None = 0,
  Pending = 1,
  Sent = 2,
  /** Deneme sınırı doldu; otomatik tekrar denenmez. */
  Failed = 3,
  /** Ayar kapalı, e-Arşiv, müşteri e-postası yok ya da özellikten önce gönderilmiş. */
  Skipped = 4,
}

export enum StockMovementDirection {
  In = 1,
  Out = 2,
}

export enum StockMovementSourceType {
  ExpenseVoucher = 1,
  Invoice = 2,
  OpeningBalance = 3,
  ManualAdjustment = 4,
  /** İptal ters kaydı. Hareketler silinmez, ters kayıtla döndürülür. */
  Reversal = 5,
  IncomingInvoice = 6,
  IncomingDespatch = 7,
}

export enum StockUnitType {
  /** Altın/gümüş — UBL birim kodu GRM. */
  Gram = 1,
  /** Sarrafiye — UBL birim kodu C62. */
  Piece = 2,
}

/**
 * Yasal stok kaleminde satış işçiliğinin nasıl ifade edildiği. Milyem tavanı
 * 1,0000 (saf altın) olduğu için işçiliği yüksek ziynette (çeyrek, ata, gremse)
 * TL modu kullanılır.
 */
export enum LegalStockPricingMode {
  /** Değer, işçilik dahil has karşılığı (gram/birim). İşçilik = değer − emtia has. */
  Milyem = 1,
  /** Değer, birim başına KDV dahil TL işçilik bedeli. */
  Amount = 2,
}

/**
 * Fatura ve gider pusulasında birim fiyatın yuvarlanacağı adım — kalem kartında
 * tutulur (JewApi DbEnums.PriceRoundingStep, birim-fiyat-yuvarlama.md).
 */
export enum PriceRoundingStep {
  None = 0,
  Whole = 1,
  Quarter = 2,
  Half = 3,
}

/** Hedefe kalan yuvarlama farkının yazıldığı yer (JewApi PriceRoundingAbsorption). */
export enum PriceRoundingAbsorption {
  None = 0,
  Quantity = 1,
  Labour = 2,
  Discount = 3,
}

export enum ExpenseVoucherStatus {
  Draft = 1,
  Issued = 2,
  Cancelled = 3,
}

/**
 * Kalemin vergi senaryosu. Currency'den TÜRETİLMEZ: aynı Currency.Gold hem hurda
 * (külçe istisnası) hem mamul ziynet (özel matrah) olabiliyor.
 */
export enum EInvoiceTaxScenario {
  /** Düz KDV. Fatura tipi SATIS. */
  Normal = 1,
  /** KDVK 23/e — matrah = satış bedeli − has altın bedeli. Kod 805, tip OZELMATRAH. */
  SpecialTaxBaseGold = 2,
  /** Gümüş ziynet/sikke gümüş. Kod 808, tip OZELMATRAH. */
  SpecialTaxBaseSilver = 3,
  /** KDVK 17/4-g külçe altın-gümüş. Kod 230, tip ISTISNA, KDV oranı 0. */
  Exempt = 4,
}

// ─── Etiketler ───────────────────────────────────────────────────────────────

export const E_INVOICE_PROVIDER_LABELS: Record<number, string> = {
  [EInvoiceProviderType.None]: 'Seçilmedi',
  [EInvoiceProviderType.Nilvera]: 'Nilvera',
  [EInvoiceProviderType.Mock]: 'Test Simülatörü',
  [EInvoiceProviderType.Nettefatura]: 'Nettefatura (İş Net)',
  [EInvoiceProviderType.Uyumsoft]: 'Uyumsoft',
  [EInvoiceProviderType.Edm]: 'EDM Bilişim',
};

export const E_INVOICE_DOCUMENT_TYPE_LABELS: Record<number, string> = {
  [EInvoiceDocumentType.None]: '-',
  [EInvoiceDocumentType.EInvoice]: 'e-Fatura',
  [EInvoiceDocumentType.EArchive]: 'e-Arşiv',
  [EInvoiceDocumentType.EDespatch]: 'e-İrsaliye',
};

export const E_INVOICE_PROFILE_LABELS: Record<number, string> = {
  [EInvoiceProfileType.None]: '-',
  [EInvoiceProfileType.Basic]: 'Temel Fatura',
  [EInvoiceProfileType.Commercial]: 'Ticari Fatura',
  [EInvoiceProfileType.Export]: 'İhracat',
  [EInvoiceProfileType.TravellerInvoice]: 'Yolcu Beraberi',
  [EInvoiceProfileType.EArchive]: 'e-Arşiv',
  [EInvoiceProfileType.Public]: 'Kamu',
  [EInvoiceProfileType.Hks]: 'HKS',
  [EInvoiceProfileType.Energy]: 'Enerji',
  [EInvoiceProfileType.MedicineAndMedicalDevice]: 'İlaç ve Tıbbi Cihaz',
  [EInvoiceProfileType.SpecialInvoice]: 'Özel Fatura',
  [EInvoiceProfileType.InvestmentIncentive]: 'Yatırım Teşvik',
  [EInvoiceProfileType.Idis]: 'İDİS',
};

export const E_INVOICE_TYPE_CODE_LABELS: Record<number, string> = {
  [EInvoiceTypeCode.None]: '-',
  [EInvoiceTypeCode.Sales]: 'Satış',
  [EInvoiceTypeCode.Return]: 'İade',
  [EInvoiceTypeCode.Exception]: 'İstisna',
  [EInvoiceTypeCode.Withholding]: 'Tevkifat',
  [EInvoiceTypeCode.ExportRegistered]: 'İhraç Kayıtlı',
  [EInvoiceTypeCode.Cancel]: 'İptal',
  [EInvoiceTypeCode.SpecialTaxBase]: 'Özel Matrah',
  [EInvoiceTypeCode.Sgk]: 'SGK',
  [EInvoiceTypeCode.WithholdingReturn]: 'Tevkifat İade',
  [EInvoiceTypeCode.Commissioner]: 'Komisyoncu',
};

export const E_INVOICE_STATUS_LABELS: Record<number, string> = {
  [EInvoiceDocumentStatus.Unknown]: 'Bilinmiyor',
  [EInvoiceDocumentStatus.Draft]: 'Taslak',
  [EInvoiceDocumentStatus.Pending]: 'Gönderiliyor',
  [EInvoiceDocumentStatus.Sent]: 'Gönderildi',
  [EInvoiceDocumentStatus.Succeed]: 'Başarılı',
  [EInvoiceDocumentStatus.Error]: 'Hata',
  [EInvoiceDocumentStatus.Cancelled]: 'İptal',
  [EInvoiceDocumentStatus.ProviderDraft]: 'Entegratörde Taslak',
  [EInvoiceDocumentStatus.AwaitingApproval]: 'Onay Bekliyor',
};

export const E_INVOICE_STATUS_BADGE: Record<number, string> = {
  [EInvoiceDocumentStatus.Unknown]: 'bg-secondary',
  [EInvoiceDocumentStatus.Draft]: 'bg-secondary',
  [EInvoiceDocumentStatus.Pending]: 'bg-info',
  [EInvoiceDocumentStatus.Sent]: 'bg-primary',
  [EInvoiceDocumentStatus.Succeed]: 'bg-success',
  [EInvoiceDocumentStatus.Error]: 'bg-danger',
  [EInvoiceDocumentStatus.Cancelled]: 'bg-dark',
  [EInvoiceDocumentStatus.ProviderDraft]: 'bg-warning text-dark',
  [EInvoiceDocumentStatus.AwaitingApproval]: 'bg-info text-dark',
};

export const E_INVOICE_ANSWER_LABELS: Record<number, string> = {
  [EInvoiceAnswerCode.Unknown]: 'Bilinmiyor',
  [EInvoiceAnswerCode.WaitingForApproval]: 'Yanıt Bekliyor',
  [EInvoiceAnswerCode.Approved]: 'Kabul',
  [EInvoiceAnswerCode.Rejected]: 'Ret',
  [EInvoiceAnswerCode.AnsweredAutomatically]: 'Otomatik Yanıtlandı',
};

export const E_INVOICE_ANSWER_BADGE: Record<number, string> = {
  [EInvoiceAnswerCode.Unknown]: 'bg-secondary',
  [EInvoiceAnswerCode.WaitingForApproval]: 'bg-warning text-dark',
  [EInvoiceAnswerCode.Approved]: 'bg-success',
  [EInvoiceAnswerCode.Rejected]: 'bg-danger',
  [EInvoiceAnswerCode.AnsweredAutomatically]: 'bg-info',
};

export const DOCUMENT_STOCK_STATUS_LABELS: Record<number, string> = {
  [DocumentStockStatus.NotApplicable]: '-',
  [DocumentStockStatus.Pending]: 'Bekliyor',
  [DocumentStockStatus.Processed]: 'İşlendi',
  [DocumentStockStatus.Ignored]: 'Yoksayıldı',
};

export const DOCUMENT_STOCK_STATUS_BADGE: Record<number, string> = {
  [DocumentStockStatus.NotApplicable]: 'bg-light text-dark',
  [DocumentStockStatus.Pending]: 'bg-warning text-dark',
  [DocumentStockStatus.Processed]: 'bg-success',
  [DocumentStockStatus.Ignored]: 'bg-secondary',
};

export const E_INVOICE_EMAIL_STATUS_LABELS: Record<number, string> = {
  [EInvoiceEmailStatus.None]: '-',
  [EInvoiceEmailStatus.Pending]: 'Gönderilecek',
  [EInvoiceEmailStatus.Sent]: 'Gönderildi',
  [EInvoiceEmailStatus.Failed]: 'Gönderilemedi',
  [EInvoiceEmailStatus.Skipped]: 'Gönderilmedi',
};

export const E_INVOICE_EMAIL_STATUS_BADGE: Record<number, string> = {
  [EInvoiceEmailStatus.None]: 'bg-light text-dark',
  [EInvoiceEmailStatus.Pending]: 'bg-warning text-dark',
  [EInvoiceEmailStatus.Sent]: 'bg-success',
  [EInvoiceEmailStatus.Failed]: 'bg-danger',
  [EInvoiceEmailStatus.Skipped]: 'bg-secondary',
};

export const STOCK_DIRECTION_LABELS: Record<number, string> = {
  [StockMovementDirection.In]: 'Giriş',
  [StockMovementDirection.Out]: 'Çıkış',
};

export const STOCK_SOURCE_LABELS: Record<number, string> = {
  [StockMovementSourceType.ExpenseVoucher]: 'Gider Pusulası',
  [StockMovementSourceType.Invoice]: 'Fatura',
  [StockMovementSourceType.OpeningBalance]: 'Açılış Bakiyesi',
  [StockMovementSourceType.ManualAdjustment]: 'Düzeltme',
  [StockMovementSourceType.Reversal]: 'Ters Kayıt',
  [StockMovementSourceType.IncomingInvoice]: 'Gelen Fatura',
  [StockMovementSourceType.IncomingDespatch]: 'Gelen İrsaliye',
};

export const STOCK_UNIT_TYPE_LABELS: Record<number, string> = {
  [StockUnitType.Gram]: 'Gram',
  [StockUnitType.Piece]: 'Adet',
};

export const LEGAL_STOCK_PRICING_MODE_LABELS: Record<number, string> = {
  [LegalStockPricingMode.Milyem]: 'Milyem',
  [LegalStockPricingMode.Amount]: 'TL',
};

export const PRICE_ROUNDING_STEP_LABELS: Record<number, string> = {
  [PriceRoundingStep.None]: 'Yok',
  [PriceRoundingStep.Whole]: 'Tam sayı',
  [PriceRoundingStep.Quarter]: '0,25',
  [PriceRoundingStep.Half]: '0,50',
};

export const PRICE_ROUNDING_STEP_OPTIONS = [
  PriceRoundingStep.None,
  PriceRoundingStep.Whole,
  PriceRoundingStep.Quarter,
  PriceRoundingStep.Half,
].map(value => ({ value, label: PRICE_ROUNDING_STEP_LABELS[value] }));

/** Önizlemedeki fark notu: "Yuvarlama farkı işçiliğe yazıldı". */
export const PRICE_ROUNDING_ABSORPTION_LABELS: Record<number, string> = {
  [PriceRoundingAbsorption.Quantity]: 'miktara',
  [PriceRoundingAbsorption.Labour]: 'işçiliğe',
  [PriceRoundingAbsorption.Discount]: 'yuvarlama indirimine',
};

export const EXPENSE_VOUCHER_STATUS_LABELS: Record<number, string> = {
  [ExpenseVoucherStatus.Draft]: 'Taslak',
  [ExpenseVoucherStatus.Issued]: 'Düzenlendi',
  [ExpenseVoucherStatus.Cancelled]: 'İptal',
};

export const EXPENSE_VOUCHER_STATUS_BADGE: Record<number, string> = {
  [ExpenseVoucherStatus.Draft]: 'bg-secondary',
  [ExpenseVoucherStatus.Issued]: 'bg-success',
  [ExpenseVoucherStatus.Cancelled]: 'bg-dark',
};

export const TAX_SCENARIO_LABELS: Record<number, string> = {
  [EInvoiceTaxScenario.Normal]: 'Normal KDV',
  [EInvoiceTaxScenario.SpecialTaxBaseGold]: 'Özel Matrah — Altın Ziynet (805)',
  [EInvoiceTaxScenario.SpecialTaxBaseSilver]: 'Özel Matrah — Gümüş Ziynet (808)',
  [EInvoiceTaxScenario.Exempt]: 'İstisna — Külçe (230)',
};

/**
 * Vergi senaryosu seçiminin ne anlama geldiği kullanıcıya açıklanmalı;
 * yalnızca enum adını yazmak yeterli değil.
 */
export const TAX_SCENARIO_HINTS: Record<number, string> = {
  [EInvoiceTaxScenario.Normal]:
    'KDV, satış bedelinin tamamı üzerinden hesaplanır.',
  [EInvoiceTaxScenario.SpecialTaxBaseGold]:
    'KDV yalnızca işçilik + kâr farkı üzerinden alınır; has altın bedeli matrahtan düşülür (KDVK 23/e).',
  [EInvoiceTaxScenario.SpecialTaxBaseSilver]:
    'Gümüş ziynet/sikke için özel matrah; has gümüş bedeli matrahtan düşülür.',
  [EInvoiceTaxScenario.Exempt]:
    'Külçe altın/gümüş tesliminde KDV yoktur (KDVK 17/4-g). KDV oranı 0 uygulanır.',
};

export const TAX_SCENARIO_BADGE: Record<number, string> = {
  [EInvoiceTaxScenario.Normal]: 'bg-secondary',
  [EInvoiceTaxScenario.SpecialTaxBaseGold]: 'bg-warning text-dark',
  [EInvoiceTaxScenario.SpecialTaxBaseSilver]: 'bg-info text-dark',
  [EInvoiceTaxScenario.Exempt]: 'bg-primary',
};

// ─── Seçenek listeleri ───────────────────────────────────────────────────────

function toOptions(labels: Record<number, string>, exclude: number[] = []) {
  return Object.keys(labels)
    .map(key => +key)
    .filter(value => exclude.indexOf(value) === -1)
    .map(value => ({ value, label: labels[value] }));
}

export const TAX_SCENARIO_OPTIONS = toOptions(TAX_SCENARIO_LABELS);
export const STOCK_UNIT_TYPE_OPTIONS = toOptions(STOCK_UNIT_TYPE_LABELS);
export const E_INVOICE_STATUS_OPTIONS = toOptions(E_INVOICE_STATUS_LABELS, [EInvoiceDocumentStatus.Unknown]);
export const EXPENSE_VOUCHER_STATUS_OPTIONS = toOptions(EXPENSE_VOUCHER_STATUS_LABELS);
export const DOCUMENT_STOCK_STATUS_OPTIONS = toOptions(DOCUMENT_STOCK_STATUS_LABELS, [DocumentStockStatus.NotApplicable]);
export const E_INVOICE_PROVIDER_OPTIONS = toOptions(E_INVOICE_PROVIDER_LABELS, [EInvoiceProviderType.None]);
export const E_INVOICE_PROFILE_OPTIONS = toOptions(E_INVOICE_PROFILE_LABELS, [EInvoiceProfileType.None]);
export const STOCK_DIRECTION_OPTIONS = toOptions(STOCK_DIRECTION_LABELS);

/** Belge tipi seçimi yalnızca fatura kesme ekranında; e-İrsaliye burada kullanılmaz. */
export const INVOICE_DOCUMENT_TYPE_OPTIONS = [
  { value: EInvoiceDocumentType.EInvoice, label: E_INVOICE_DOCUMENT_TYPE_LABELS[EInvoiceDocumentType.EInvoice] },
  { value: EInvoiceDocumentType.EArchive, label: E_INVOICE_DOCUMENT_TYPE_LABELS[EInvoiceDocumentType.EArchive] },
];

/**
 * Birim seçiminden türetilen UBL birim kodu — faturanın satırına giden resmî kod.
 * Ekranda gösterilmiyor; kullanıcı birimi (Gram/Adet) seçiyor, kod buradan çıkıyor.
 */
export const UBL_UNIT_CODE_BY_UNIT_TYPE: Record<number, string> = {
  [StockUnitType.Gram]: 'GRM',
  [StockUnitType.Piece]: 'C62',
};

/** Özel matrah senaryosu mu — kırılım gösterilip gösterilmeyeceğini belirler. */
export function isSpecialTaxBase(scenario: EInvoiceTaxScenario): boolean {
  return scenario === EInvoiceTaxScenario.SpecialTaxBaseGold
    || scenario === EInvoiceTaxScenario.SpecialTaxBaseSilver;
}

/**
 * JewApi.Biz/Managers/EInvoice/BankInvoiceModels.cs — BankInvoicePricingMode
 *
 * Banka faturasında satırların nasıl fiyatlandığı; fatura kesme ekranındaki üç
 * yöntemin aynısı. Sıfır eski davranış: alanı göndermeyen istemciler hedeften
 * fiyatlamada kalır.
 */
export enum BankPricingMode {
  /** Hızlı Düzenle: kalem ve miktar girilir, birim fiyatlar toplamdan türetilir. */
  Target = 0,
  /** Otomatik: satırı da hesap üretir. */
  Automatic = 1,
  /** Tam Düzenle: birim fiyat ve işçilik kullanıcınındır; toplam kesimde kontrol edilir. */
  Manual = 2,
}

/**
 * JewApi.Biz/Managers/EInvoice/BankInvoiceModels.cs — BankCustomerMatchKind
 *
 * Cari kartının banka hareketinden hangi bilgiyle çözüldüğü. Güven sırası:
 * VKN/TCKN yasal kimliktir, IBAN cari kartına kayıtlı hesaptır, ad ise kimlik
 * DEĞİLDİR — ad eşleşmesi kullanıcıya doğrulatılacak bir ipucudur.
 */
export enum BankCustomerMatchKind {
  /** Hiçbir bilgiyle eşleşmedi; ekran "müşteri bulunamadı" der. */
  None = 0,
  TaxNumber = 1,
  Iban = 2,
  /** Gönderen adı tek bir cariyle birebir eşleşti — zayıf eşleşme. */
  Name = 3,
  /** Hareket bir cariye bağlanmış (defter kaydının müşterisi); diğer ipuçlarından önce gelir. */
  Ledger = 4,
}
